import { $api } from '../../global';

export const getAllUniversities =
  ({
    page,
    type,
    search,
    isNotWeb = false,
    addressId,
    size = 12
  }: {
    size?: number;
    search?: string;
    isNotWeb?: boolean;
    page?: string | string[];
    type?: string | string[];
    addressId?: string | string[];
  }) =>
  async () => {
    const { data } = await $api.get('/university-all', {
      params: {
        page,
        address_id: addressId,
        type,
        is_web: isNotWeb ? undefined : 1,
        size: isNotWeb ? 99 : size,
        search
      }
    });

    return data;
  };
